import {User} from '@/Models';
import {usePage} from '@inertiajs/vue2';

export const useCurrentUser = (): User => {
    const page = usePage();
    return (page.props as any).auth.user.data;
}
